// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Center } from '@/components/ui/layout';
import { Title, Text, Button } from '@/components/ui/core';
import { PasswordInput } from '@/components/ui/inputs';
import { IconLock, IconArrowLeft, IconLockCheck } from '@tabler/icons-react';
import { AuthLayoutWrapper, PasswordStrength } from '../components';

export default function ResetClassicMinimal() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Reset password:', password);
  };

  const passwordsMatch = password === confirmPassword;
  const canSubmit = password.length >= 8 && passwordsMatch;

  return (
    <AuthLayoutWrapper variant="simple">
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/reset-password"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={{
                width: 56,
                height: 56,
                borderRadius: 14,
                backgroundColor: 'var(--mantine-color-green-light)',
              }}
            >
              <IconLockCheck size={28} color="var(--mantine-color-green-6)" />
            </Center>
            <Title order={2} ta="center">Set new password</Title>
            <Text c="dimmed" size="sm" ta="center" maw={300}>
              Your new password must be different from previous passwords.
            </Text>
          </Stack>
        </Center>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <div>
              <PasswordInput
                label="New password"
                placeholder="Enter new password"
                leftSection={<IconLock size={16} />}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {password && <PasswordStrength password={password} variant="bar" />}
            </div>

            <PasswordInput
              label="Confirm password"
              placeholder="Confirm new password"
              leftSection={<IconLock size={16} />}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              error={confirmPassword && !passwordsMatch ? "Passwords don't match" : undefined}
            />

            <Button type="submit" fullWidth disabled={!canSubmit}>
              Reset password
            </Button>
          </Stack>
        </form>

        {/* Back to Login */}
        <Center>
          <Button
            component={Link}
            to="/app/demo/auth-pages/login/simple"
            variant="subtle"
            leftSection={<IconArrowLeft size={14} />}
          >
            Back to login
          </Button>
        </Center>
      </Stack>
    </AuthLayoutWrapper>
  );
}
